import {BoxAccess, PushButton, usePlatform, usePreventDeactivate, View} from "@variocube/cube-ui";
import {useLocalization} from "../i18n";
import {Fragment} from "react";
import * as React from "react";
import {Box} from "@variocube/app-api";
import {stylesheet} from "typestyle";


interface StorageBoxAccessProps {
    boxes: Box[];
    onCancel: () => void;
    onConfirm: () => void;
}

export function StorageBoxAccess(props: StorageBoxAccessProps) {
    const platform = usePlatform();
    const {t} = useLocalization();

    usePreventDeactivate();

    const boxNames = props.boxes.map(box => box.number).join(", ");

    return (<View className={styles.viewFull}>
            <BoxAccess
                platform={platform}
                boxes={props.boxes}
                onCancel={props.onCancel}
                onConfirm={props.onConfirm}
                timeout={false}
                strings={t}
                boxOpenTitle={t("DeliveryStoreTitle")}
                boxOpenMessage={t("DeliveryStoreMessage", {boxNames})}
                confirmTitle={t("DeliveryConfirmTitle")}
                confirmMessage={t("DeliveryConfirmMessage", {boxNames})}
                openActions={<Fragment>
                    <PushButton onClick={props.onCancel}>
                        {t("Cancel")}
                    </PushButton>
                </Fragment>}
            />
        </View>)
}

const styles = stylesheet({
    viewFull: {
        position: "fixed", top: 0, width: "100% !important", height: "100% !important"
    }
});
